/**
 * @file
 *
 * Component for generate display of the pdf files with events for pagination, zoom scale, resize page and 
 * rotate page. This component also control flow when pdf this protege with password.
 * The logic of the pdf navegator bar is in the component 'NavegadorPDF'
 * @author alejjahi
 */

import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { Form } from "react-final-form";
import { REQUEST } from "../../../config/ajax-wrapper";
import PDFJS from 'pdfjs-dist';
import NavegadorPDF from './NavegadorPDF';

class VisualizadorPDF extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.onDocumentComplete = this.onDocumentComplete.bind(this);
        this.onPageComplete = this.onPageComplete.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSubmitPassword = this.onSubmitPassword.bind(this);
        this.state = {
            password: '',
            estadoPDF: REQUEST.NONE,
            canvas: null,
            zoomPagina: 1.2,
            zoomMin: 0.9,
            zoomMax: 1.95,
            rotacionPagina: 0
        };
    }  

    onDocumentComplete(pdf: any) {
        this.setState({ pdf: pdf });
        const {onDocumentComplete} = this.props;
        if (typeof onDocumentComplete === 'function') {
            onDocumentComplete(pdf.numPages);
        }
        pdf.getPage(this.props.pagina).then(this.onPageComplete);
    }

    onPageComplete(pagina: any) {
        this.setState({pagina: pagina});
        this.renderPDF();
        const {onPageComplete} = this.props;
        if (typeof onPageComplete === 'function') {
            onPageComplete(pagina.pageIndex + 1);
        }
    }

    renderPDF() {
        const {pagina, zoomPagina, rotacionPagina} = this.state;
        if (pagina) {
            const canvasContext = this.state.canvas.current.getContext('2d');
            const viewport = pagina.getViewport({ scale: zoomPagina, rotation: rotacionPagina });
            this.state.canvas.current.height = viewport.height;
            this.state.canvas.current.width = viewport.width;
            pagina.render({canvasContext, viewport});
        }
    }

    componentDidMount() {
        this.setState({estadoPDF: REQUEST.PENDING});
        this.abrirDocumentoPDF();
    }

    render() {
        const {estadoPDF} = this.state;
        switch (estadoPDF) {
            case REQUEST.SUCCESS: {
                return(
                    <div className={"visualizador-pdf"}>
                        {this.renderNavegadorPDF()} 
                        <div className={"visor-documentos"}>
                            <canvas ref={this.state.canvas}/>
                        </div>
                        {this.renderNavegadorPDF()} 
                    </div>
                );
            }
            case REQUEST.PENDING: {
                return(
                    <div>Generando documento PDF...</div>
                );
            }
            case REQUEST.FORBIDDEN: {
                return(
                    <div>
                        <Row>
                            <Form
                                onSubmit={this.onSubmitPassword}
                                render={({ handleSubmit, invalid, submitting }) => (
                                    <form onSubmit={handleSubmit}>
                                        <div className={"card"}>
                                            <div className={"card-body"}>
                                                <Row className="form-group">
                                                    <Col sm={5}>
                                                        <div>Este documento está protegido, ingrese la contraseña para visualizarlo.</div>
                                                    </Col>
                                                </Row>
                                                <Row className="form-group">
                                                    <Col sm={1}>
                                                        <label  style={{fontSize: '125%'}} htmlFor="passwordPDF">Contraseña</label>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <input className="form-control" type="password" name="passwordPDF" id="passwordPDF" placeholder="Ingrese la contraseña" 
                                                            value={this.state.password} onChange={this.handleChange} 
                                                        />
                                                    </Col>
                                                    <Col sm={1}>
                                                        <button type="submit" className="btns btns-primary" 
                                                            disabled={submitting || invalid}>
                                                            Ingresar
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            />
                        </Row>
                    </div>
                );
            }
            case REQUEST.ERROR: {
                return(
                    <div>Se presentó un error al generar el documento!</div>
                );
            }
            default: {
                return(
                    <label>Cargando...</label>
                );
            }
        }
    }

    onSubmitPassword() {
        this.abrirDocumentoPDF();
    }

    handleChange(event: any) {
        this.setState({password: event.target.value});
    }

    abrirDocumentoPDF() {
        const documentoP8 = Buffer.from(this.props.documentoBase64,'base64');
        PDFJS.getDocument({data: documentoP8, password: this.state.password, }).promise.then(
            loadPDF => {
                const paginaInicial = 1;
                this.setState({
                    pdf: loadPDF,
                    pagina: loadPDF.getPage(paginaInicial).then(this.onPageComplete), 
                    estadoPDF: REQUEST.SUCCESS,
                    canvas: React.createRef(),
                    totalPaginas: loadPDF.numPages
                });
                this.props.showBtnRotate();
            } 
        ).catch(
            error => {
                if(error.name === 'PasswordException') {
                    this.setState({password: '', estadoPDF: REQUEST.FORBIDDEN});
                } else {
                    this.setState({estadoPDF: REQUEST.ERROR});
                }
            }
        );
    }

    renderNavegadorPDF() {
        if(this.state.totalPaginas > 0 && this.state.pagina) {
            return(
                <NavegadorPDF
                    indexPagina={this.state.pagina.pageIndex + 1}
                    totalPaginas={this.state.totalPaginas}
                    zoomPagina={this.state.zoomPagina}
                    zoomMin={this.state.zoomMin}
                    zoomMax={this.state.zoomMax}
                    eventoPaginaSiguiente={this.eventoPaginaSiguiente}
                    eventoPaginaPrevia={this.eventoPaginaPrevia}
                    eventZoomIn={this.eventZoomIn}
                    eventZoomOut={this.eventZoomOut}
                    eventResizeScale={this.eventResizeScale}
                />
            );
        }
    }

    eventoPaginaPrevia = () => {
        const indexPagina = (this.state.pagina.pageIndex + 1);
        if (indexPagina === 1) return;
        this.renderPagina(indexPagina - 1);
    }
    
    eventoPaginaSiguiente = () => {
        const indexPagina = (this.state.pagina.pageIndex + 1);
        if (this.state.pagina.pageIndex === this.state.totalPaginas) return;
        this.renderPagina(indexPagina + 1);
    }

    eventZoomIn = () => {
        if (this.state.zoomPagina >= this.state.zoomMax) return;
        this.setState((prevState: any) => ({ zoomPagina: prevState.zoomPagina + 0.15 }), () => this.renderPDF());
    }

    eventZoomOut = () => {
        if (this.state.zoomPagina <= this.state.zoomMin) return;
        this.setState((prevState: any) => ({ zoomPagina: prevState.zoomPagina - 0.15 }), () => this.renderPDF());
    }

    eventResizeScale = () => {
        const {zoomPagina,rotacionPagina,pagina} = this.state;
        const viewport = pagina.getViewport({ scale: zoomPagina, rotation: rotacionPagina });
        const newScale = Math.round((1024/Math.abs(viewport.viewBox[3] - viewport.viewBox[1])) * 1e2) / 1e2;
        this.setState({ zoomPagina: (newScale > 0.2 ? newScale : 0.2 ), zoomMin: (newScale > 0.2 ? (newScale * (0.75) ) : 0.2 ) }, () => this.renderPDF());
    }

    renderPagina(indexPagina: any) {
        if(indexPagina > 0 && this.state.pagina) {
            const pagina = this.state.pdf.getPage(indexPagina).then(this.onPageComplete);
            this.setState({ pagina: pagina });
        }
    }
}

export default VisualizadorPDF; 


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/VisualizadorPDF.tsx